<script>
    import { params, redirect } from "@roxi/routify";
    import { LoginService } from "../../services/LoginService";
    import { LocalStorage } from "../../services/LocalStorage";

    const getRedirectUrl = async () => {
        let redirectUrl = await LocalStorage.get("IN_APP_REDIRECT");
        await LocalStorage.remove("IN_APP_REDIRECT");
        return redirectUrl;
    };
</script>

{#await LoginService.authCodeLogin($params.id, $params.code)}
    <h3>Verifying user...</h3>
{:then result}
    {#await getRedirectUrl()}
        Redirecting...
    {:then redirectUrl}
        {#if redirectUrl}
            {$redirect(redirectUrl)}
        {:else}
            {$redirect("/")}
        {/if}
    {/await}
{:catch}
    Something went wrong
{/await}
